import template from './additionalProducts.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    additionalProducts: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdUtil, $mdMedia, helperService, assetFinanceService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableAssetFinanceInsuranceTypes = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableAssetFinanceInsuranceTypes = assetFinanceService.getAvailableAssetFinanceInsuranceTypes();
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: false
        });
        ctrl.additionalProducts = ctrl.additionalProducts || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.additionalProductsAdd = (insuranceType) =>
        assetFinanceService.additionalProductsAdd(ctrl.additionalProducts, insuranceType);

      ctrl.additionalProductsDelete = (additionalProduct) => {
        helperService
          .deleteItem(
            ctrl.additionalProducts,
            additionalProduct,
            'Additional product',
            additionalProduct.insuranceType.name
          )
          .then((result) => {
            if (result) {
              ctrl.saveAdditionalProducts();
            }
          });
      };

      /*
       * Save additional products
       * --------------------------------------------------------------------------------
       */
      ctrl.saveAdditionalProducts = $mdUtil.debounce((additionalProduct) => {
        if (additionalProduct) {
          const idx = helperService.findIndexById(
            ctrl.additionalProducts,
            additionalProduct.id
          );
          if (idx > -1) {
            ctrl.additionalProducts.splice(idx, 1);
            ctrl.additionalProducts.splice(idx, 0, additionalProduct);
          } else {
            ctrl.additionalProducts.push(additionalProduct);
          }
        }
        ctrl.onFinished({ additionalProducts: ctrl.additionalProducts });
      }, 1500);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
